var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 43 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .73)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 43,
    height: 43,
    rx: 21.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F6F8FA",
    cx: 21.686,
    cy: 21.693,
    rx: 13.134,
    ry: 13.139
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 25.266a3.496 3.496 0 1 1 0-6.992 3.496 3.496 0 0 1 0 6.992m6.753-3.496c0-.617.648-1.188 1.747-1.655a8.611 8.611 0 0 0-1.318-3.185c-1.108.447-1.97.501-2.407.065-.436-.437-.382-1.299.065-2.407a8.61 8.61 0 0 0-3.185-1.318c-.467 1.099-1.038 1.747-1.655 1.747s-1.188-.648-1.655-1.747a8.61 8.61 0 0 0-3.185 1.318c.447 1.108.501 1.97.065 2.407-.437.436-1.3.382-2.407-.065A8.612 8.612 0 0 0 13 20.115c1.099.467 1.747 1.038 1.747 1.655s-.648 1.188-1.747 1.656c.225 1.16.68 2.24 1.318 3.184 1.108-.446 1.97-.501 2.407-.065.436.437.382 1.3-.065 2.407a8.611 8.611 0 0 0 3.185 1.318c.467-1.099 1.038-1.747 1.655-1.747s1.188.648 1.655 1.747a8.611 8.611 0 0 0 3.185-1.318c-.447-1.108-.501-1.97-.065-2.407.437-.436 1.3-.381 2.407.065A8.612 8.612 0 0 0 30 23.426c-1.099-.468-1.747-1.039-1.747-1.656",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightSystemIcon);
export default __webpack_public_path__ + "static/media/highlightSystemIcon.1408f4b576ea34e9a1543fbd3dff84f3.svg";
export { ForwardRef as ReactComponent };